var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('polyline',{attrs:{"points":"22 17 13.5 8.5 8.5 13.5 2 7"}}),_c('polyline',{attrs:{"points":"16 17 22 17 22 11"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }